import { getTherapyDecsion } from '@api/train'
import brands from '@/brands.json'

const train = {
  state: {
    decsion: {},
    combinationList: [],
  },
  mutations: {
    setDecsion: (state, decsion) => {
      state.decsion = decsion
    },
    setCombinationList: (state, combination) =>
      (state.combinationList = combination),
  },
  actions: {
    // async GetDecsion({ dispatch, commit, state }) {
    //   let res = await getTherapyDecsion()
    //   const decsion = res.data.reduce(
    //     (pre, next) => (pre.weight > next.weight ? pre : next)
    //   )
    //   await commit('setDecsion', decsion)
    //   dispatch('GetCombinationList')
    // },
    // async GetCombinationList({ commit, state }) {
    //   state.decsion.combinationList.forEach(async item =>
    //     commit('setCombinationList', await getCombination(item.cid))
    //   )
    // },
    GetDecsion({ commit }) {
      return new Promise((resolve, reject) => {
        const curBrand = brands[process.env.VUE_APP_CUR_BRAND]
        console.log(curBrand, 'curBrand')
        getTherapyDecsion({
          user_type: 'ROLE_VTX',
          hospitalType:
            curBrand.hospitalType || 10001,
        })
          .then(res => {
            const decsion = res.data.reduce(
              (pre, next) => (pre.weight > next.weight ? pre : next)
            )
            commit('setDecsion', decsion)
            commit(
              'setCombinationList',
              decsion.combinationList.length ? decsion.combinationList : []
            )
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
  getters: {
    combinationTpye(state) {
      let type = []
      state.combinationList.map(item => {
        let name = item.name.split('-')[0]
        if (!type.includes(name)) {
          type.push(name)
        }
      })
      return type
    },
    combinationList: state => {
      let map = {}
      let dest = []
      let arr = state.combinationList
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        // 如果 组合名带有 "-" 说明有二级分类
        if (!map[obj.name.split('-')[0]]) {
          dest.push({
            cid: obj.cid,
            name: obj.name.split('-')[0],
            data: [obj],
          })
          map[obj.name.split('-')[0]] = obj
        } else {
          for (let j = 0; j < dest.length; j++) {
            var dj = dest[j]

            if (dj.name === obj.name.split('-')[0]) {
              dj.data.push(obj)
              break
            }
          }
        }
      }
      return dest
    },
    comTrainList: state => {
      let temp = []
      let hash = {}
      let arr = state.combinationList
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].trainList && arr[i].trainList.length) {
          temp = temp.concat(arr[i].trainList)
        }
      }
      temp = temp.reduce((item, next) => {
        if (!hash[next.gid]) {
          hash[next.gid] = true
          item.push(next)
        }
        return item
      }, [])
      return temp
    },

    // async GetDecsion({ commit, state }) {
    //   let res = await getTherapyDecsion()
    //   const decsion = res.data.reduce(
    //     (pre, next) => (pre.weight > next.weight ? pre : next)
    //   )
    //   await commit('setDecsion', decsion)
    //   await commit('setCombinationList', state.decsion.combinationList.length ? state.decsion.combinationList : null)
    // },
  },
}
export default train
